'use client';

import Chat from '../../assets/chat-bubbles.svg';

import Image from 'next/image';
import { useState } from 'react';
import {
  NO_WA_CHATBOT_PAGES,
  WA_CHATBOT_ALTERNATE_MOBILE_UI_PAGES,
  WA_CHATBOT_ALTERNATE_MOBILE_UI_EXCEPTIONS,
} from './constants';
import { useModal } from './Modal';
import { TypeformSnippet } from './TypeformSnippet';
import Cross from '../../assets/cross-icon.svg';
import { CaretUp } from '../../assets/icons';
import { useInternalPathname } from 'hooks/navigation/useInternalPathname';
import stringShortMatcher from 'utils/stringShortMatcher';
import { useTranslations } from 'next-intl';
import styles from './WAChatbot.module.css';

export const BookCallTFComponentDiv = ({
  trackingParams,
}: {
  trackingParams?: {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
  };
}) => {
  const t = useTranslations('common');
  return (
    <div className={styles.bookCallRoot}>
      <TypeformSnippet
        typeformId="yOi1E7Wy"
        frameTitle={t('wAChatbot.typeformSnippet.frameTitle.bookCall')}
        className="typeform-container"
        trackingParams={trackingParams}
      />
    </div>
  );
};

export const ChatBot = () => {
  return <WAChatbot />;
};
export default ChatBot;

const WAChatbot = () => {
  const t = useTranslations('common');
  const internalPathname = useInternalPathname();
  const routePath =
    internalPathname.length > 1
      ? internalPathname.replace(/\/$/, '')
      : internalPathname;
  const ModalClient = useModal();
  const [isVisible, setVisible] = useState(false);
  if (NO_WA_CHATBOT_PAGES.some((page) => routePath.startsWith(page)))
    return null;

  const showBookCallModal = () => {
    let url = 'website';
    if (window) {
      url = window.location.hostname + window.location.pathname;
    }
    ModalClient.set(
      <BookCallTFComponentDiv
        trackingParams={{ utm_source: url, utm_medium: 'float-button' }}
      />,
    );
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
    setVisible(false);
  };

  const regexPatterns = WA_CHATBOT_ALTERNATE_MOBILE_UI_PAGES.map(
    (pattern) => new RegExp(`^${pattern.replace('*', '.*')}$`),
  );

  const shouldShowAlternateUI =
    regexPatterns.some((regex) => regex.test(routePath)) &&
    !WA_CHATBOT_ALTERNATE_MOBILE_UI_EXCEPTIONS.includes(routePath);

  const renderSecondaryAction = () => {
    if (stringShortMatcher(routePath, '/performance-lab*')) {
      return (
        <button onClick={() => window.open('tel:+918047282422')}>
          {t('wAChatbot.button.talkToSpecialist')}
          <CaretUp style={{ transform: 'rotate(90deg)' }} />
        </button>
      );
    }
    if (
      stringShortMatcher(routePath, '/ring/order*') ||
      stringShortMatcher(routePath, '/ring/claim*')
    ) {
      return (
        <button
          onClick={() => {
            window.open(`mailto:support@ultrahuman.com`, '_blank');
          }}
        >
          {t('wAChatbot.button.emailSupport')}
          <CaretUp style={{ transform: 'rotate(90deg)' }} />
        </button>
      );
    }
    return (
      <button onClick={showBookCallModal}>
        {t('wAChatbot.button.prePurchaseConsultation')}
        <CaretUp style={{ transform: 'rotate(90deg)' }} />
      </button>
    );
  };

  return (
    <div
      data-chatbot
      className={`${styles.root} ${
        shouldShowAlternateUI ? styles.alternateMobile : ''
      }`}
    >
      <div
        className={`chatbot-container ${styles.chatbotContainer} ${isVisible ? styles.active : ''}`}
      >
        {renderSecondaryAction()}
      </div>
      <button
        onClick={() => setVisible(!isVisible)}
        className={`chatbot-toggle-button ${styles.chatbotToggleButton}`}
        style={{
          background: isVisible ? 'transparent' : '',
          // filter: isVisible ? 'none' : undefined,
          backdropFilter: isVisible ? 'none' : undefined,
          border: isVisible ? 'none' : undefined,
        }}
      >
        {isVisible ? (
          <Image src={Cross} className={styles.crossbtn} alt="chat_bot_icon" />
        ) : (
          <Image src={Chat} alt="chat_bot_icon" />
        )}
      </button>
    </div>
  );
};
